import React from 'react'
import Header from 'components/Client/Header/Header'
import PropTypes from 'prop-types'
import styles from './NameHeader.module.scss'

const NameHeader = (props) => {
  const { name } = props

  return (
    <Header className={styles.NameHeader}>
      <div className={styles.name} data-test-id="nameHeader">{name}</div>
    </Header>
  )
}

NameHeader.propTypes = {
  name: PropTypes.string.isRequired
}

export default NameHeader



// WEBPACK FOOTER //
// ./src/components/Client/NameHeader/NameHeader.jsx